import { getAxios } from '@konova/axios/get-axios';
import type { CreateClientConfig } from './client/client.gen';

const API_URL = import.meta.env.VITE_API_URL;
if (!API_URL) {
  throw new Error('No VITE_API_URL variable provided');
}


const url = URL.canParse(API_URL) ? new URL(API_URL) : window.location

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  axios: getAxios(),
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  withCredentials: true,
  baseURL: url.origin
});